import React from "react";
import BlogDetails from "../components/Blogs/BlogDetails";

function BlogDetailsPage() {
  return (
    <div>
      <BlogDetails />
    </div>
  );
}

export default BlogDetailsPage;
